type ScrollEvent = Event & { target: EventTarget & { offsetHeight: number; scrollTop: number; scrollHeight: number } };
type ScrolDebouncerData = { groupUniqueKey: string; group: any; htmlElement: any };

enum GroupingFieldsEnum {
  ProjectStage = 'project_stage',
  AssignedUser = 'assigned_user',
  CreatedBy = 'created_by_id',
  DealLead = 'deal_lead_user_id',
  DevAnalyst = 'dev_analyst_user_id',
  DevManager = 'dev_manager_user_id',
  ExecutionLead = 'execution_lead_user_id',
  MarketStatus = 'market_status_id',
  TemplateId = 'template_id',
  ProjectType = 'project_type_id',
  TenancyType = 'tenancy_type',
  LeaseType = 'lease_type',
}

export { ScrollEvent, ScrolDebouncerData, GroupingFieldsEnum };
